import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=cd42b034"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports